import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { MOBILE } from '../../../utils/constants';

interface Props {
  tags: string[];
}

const Tags = ({ tags }: Props) => {
  return (
    <>
      {tags.map((tag, index) => (
        <a
          key={tag}
          href="#"
          css={regularTagStyles}
          onClick={(e) => e.preventDefault()} // Prevent navigation for now
        >
          {tag}
        </a>
      ))}
    </>
  );
};

const regularTagStyles = css({
  padding: '4px 8px',
  fontSize: '11px',
  fontWeight: 500,
  borderRadius: '4px',
  backgroundColor: token('color.background.neutral'),
  color: token('color.text.subtle'),
  textDecoration: 'none',
  border: `1px solid ${token('color.border')}`,
  fontFamily: 'Inter, sans-serif',
  '&:hover': {
    backgroundColor: token('color.background.neutral.hovered'),
    color: token('color.text'),
    borderColor: token('color.border.focused'),
  },
  [MOBILE.MEDIA_QUERY]: {
    fontSize: '10px',
    padding: '3px 6px',
  },
});

export default Tags;
